import { render, staticRenderFns } from "./label-edit.vue?vue&type=template&id=e1c3bacc&scoped=true&"
import script from "./label-edit.vue?vue&type=script&lang=js&"
export * from "./label-edit.vue?vue&type=script&lang=js&"
import style0 from "./label-edit.vue?vue&type=style&index=0&id=e1c3bacc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c3bacc",
  null
  
)

export default component.exports